export default "__VITE_ASSET__Bm7jZx8P__"